import * as React from "react";
import {
  Applicant,
  ApplicantTypeLiterals,
  ApplicantTypeState,
} from "../../../../../application/domain/application/application-entity";
import { ApplicantInfoCorporate } from "./corporate";
import { ApplicantInfoIndividual } from "./individual";
import { ApplicantInfoUnIncorporatedGroup } from "./unincorprate_group";

export const ApplicantInfo: React.FC<{
  getApplicantValue: (key: keyof Applicant) => string | undefined;
  applicantType: ApplicantTypeLiterals;
}> = ({ getApplicantValue, applicantType }) => {
  return (
    <div className="table-container">
      <table className="table">
        <tbody>
          {new ApplicantTypeState(applicantType).matchType({
            CORPORATE: (
              <ApplicantInfoCorporate getApplicantValue={getApplicantValue} />
            ),
            INDIVIDUAL: (
              <ApplicantInfoIndividual getApplicantValue={getApplicantValue} />
            ),
            UNINCORPORATED_GROUP: (
              <ApplicantInfoUnIncorporatedGroup
                getApplicantValue={getApplicantValue}
              />
            ),
          })}
        </tbody>
      </table>
    </div>
  );
};
